export const GET_EHEALTH_RECIPE_START = 'RECIPE/GET_EHEALTH_RECIPE_START';
export const GET_EHEALTH_RECIPE_SUCCESS = 'RECIPE/GET_EHEALTH_RECIPE_SUCCESS';
export const GET_EHEALTH_RECIPE_FAILURE = 'RECIPE/GET_EHEALTH_RECIPE_FAILURE';

export const GET_EHEALTH_DRUGSTORES_START =
  'RECIPE/GET_EHEALTH_DRUGSTORES_START';
export const GET_EHEALTH_DRUGSTORES_SUCCESS =
  'RECIPE/GET_EHEALTH_DRUGSTORES_SUCCESS';
export const GET_EHEALTH_DRUGSTORES_FAILURE =
  'RECIPE/GET_EHEALTH_DRUGSTORES_FAILURE';

export const ADD_TO_CART = 'RECIPE/ADD_TO_CART';

export const SET_LOCATION = 'RECIPE/SET_LOCATION';

export const SET_MAP_CENTER = 'RECIPE/SET_MAP_CENTER';

export const SET_CART_ITEM_COUNT = 'RECIPE/SET_CART_ITEM_COUNT';

export const SELECT_OFFER = 'RECIPE/SELECT_OFFER';

export const SET_LOADER = 'RECIPE/SET_LOADER';

export const STORE_ORDER_START = 'RECIPE/STORE_ORDER_START';
export const STORE_ORDER_SUCCESS = 'RECIPE/STORE_ORDER_SUCCESS';
export const STORE_ORDER_FAILURE = 'RECIPE/STORE_ORDER_FAILURE';

export const SET_V_ERRORS = 'RECIPE/SET_V_ERRORS';

export const FLUSH_CONFIRM = 'RECIPE/FLUSH_CONFIRM';

export const FLUSH_ALL = 'RECIPE/FLUSH_ALL';
